import streamers from '../images/streamers.jpg'

css .ministry-partners-page
	min-height:100vh
	d:flex
	fld:column
	.shape-header
		h:300px
	.copy
		d:flex
		fld:column
		gap:1em
				
tag ministry-partners-page
	<self.ministry-partners-page>
		<shape-header title="Ministry Partners" image=streamers>
		<text-block.who-we-are title="Ministry Partners">
			<div.copy>
				<p> "Grace has a long history of partnering with other communities of faith and organizations toward the healing of San Antonio."
				<strong> "CAM"
				<p> 
					"As a founding member of "
					<a href="https://christianassistanceministry.org"> "Christian Assistance Ministry (CAM)"
					" we have housed this incredible ministry on our campus free of charge since 1977. CAM is San Antonio’s “emergency room” for critical assistance designed to help people with bridge services in times of critical need. In addition to rental, utility, food and medical assistance CAM also offers mail services, ID recovery, daily meals, showers and has piloted a mental health program with the City of San Antonio. We are so proud of the partnership we share with CAM."
				<strong> "Corazon Ministries"
				<p>
					"In addition to CAM our campus also hosts "
					<a href="https://corazonministries.org"> "Corazon Ministries"
					" respite center, harm reduction center and medical clinic. Clients can spend time in our fellowship hall for a safe, cool (or warm) space, get lunch, grab a shower, enlist case management, receive medical care and get critical harm reduction supplies. Corazon ministries brings so many of our neighbors through our doors and we are grateful for the amazing healing work they do on a daily basis."
				<strong> "Extreme Weather Shelter"
				<p>
					"Because of our partnership with Corazon Ministries, Grace becomes an overnight shelter when needed for extreme weather in San Antonio."
				<strong> "LULAC"
				<p>
					"Grace is proud of our partnership with the "
					<a href="https://lulac.org/fun/san-antonio/about_us">
						"League of United Latin American Citizens of San Antonio (LULAC)"
					". LULAC utilizes our campus for meetings, events, supplies and distribution of community service. In addition to the ministry we share with these organizations on our campus we have a rich history with partnering with other San Antonio ministries such as Habitat for Humanity, Meals on Wheels, Interfaith San Antonio Alliance, Fiesta Flambeau, Platicas de Santa Sophia, THUGGIN for Christ, San Antonio Lutheran Coronation and many more."

		<footer-section>